class HouseBoxAuto {
  constructor() {
    this.houseBoxVariantId = 53438654251305;
    this.processing = false;

    this.evaluateCart();
  }

  async getCart() {
    const response = await fetch('/cart.js');

    if (!response.ok) {
      throw new Error('Unable to retrieve cart');
    }

    return response.json();
  }

  getHouseBox(cart) {
    return cart.items.find(
      item => Number(item.variant_id) === Number(this.houseBoxVariantId)
    );
  }

  hasDarlingDress(cart) {
    return cart.items.some(item => {
      return (
        Number(item.variant_id) !== Number(this.houseBoxVariantId) &&
        item.properties &&
        item.properties._house_box_darling === 'true'
      );
    });
  }

  getQualifyingSubtotal(cart) {
    return cart.items
      .filter(
        item =>
          Number(item.variant_id) !== Number(this.houseBoxVariantId)
      )
      .reduce(
        (total, item) => total + item.final_line_price,
        0
      );
  }

  async evaluateCart() {
    if (this.processing) return;

    this.processing = true;

    try {
      const cart = await this.getCart();

      const houseBox = this.getHouseBox(cart);
      const qualifiesByDarling = this.hasDarlingDress(cart);

      // $1,000 = 100000 cents
      const qualifiesBySpend =
        this.getQualifyingSubtotal(cart) >= 100000;

      const qualifies =
        qualifiesByDarling || qualifiesBySpend;

      console.log('House Box check:', {
        qualifiesByDarling,
        qualifiesBySpend,
        houseBoxFound: !!houseBox
      });

      if (qualifies && !houseBox) {
        const added = await this.addHouseBox();

        if (added) {
          window.location.reload();
        }

        return;
      }

      if (
  !qualifies &&
  houseBox &&
  houseBox.properties &&
  houseBox.properties._complimentary_house_box === 'true'
) {
  const removed = await this.removeHouseBox(houseBox);

  if (removed) {
    window.location.reload();
  }
}

    } catch (error) {
      console.error(
        'House Box automation error:',
        error
      );
    } finally {
      this.processing = false;
    }
  }

  async addHouseBox() {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: Number(this.houseBoxVariantId),
            quantity: 1,
            properties: {
              _complimentary_house_box: 'true'
            }
          }
        ]
      })
    });

    if (!response.ok) {
      const error = await response.json();

      console.error(
        'House Box could not be added:',
        error
      );

      return false;
    }

    return true;
  }

  async removeHouseBox(houseBox) {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: houseBox.key,
        quantity: 0
      })
    });

    if (!response.ok) {
      const error = await response.json();

      console.error(
        'House Box could not be removed:',
        error
      );

      return false;
    }

    return true;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new HouseBoxAuto();
});